import { VuexModule, Module, Action, Mutation } from 'vuex-module-decorators';
import { ApiClient } from '@sfs-projects/sfs-fc-api-sdk';

@Module({ namespaced: true })
class AirlineModule extends VuexModule {
  public ListAirlines: Array<string> = [];
  public ListLanguages: Array<string> = [];
  public Languages: Array<string> = [];
  public Reports: Array<string> = [];
  public ListReports: any = [];
  public ListRates: any = [];
  public ListCurrency: Array<object> = [];

  @Mutation
  public setConfig(config: any) {
    this.Languages = config.ListLanguages;
    this.ListLanguages = config.ListLanguages;
    this.Reports = config.ListReports;
    this.ListReports = config.ListReports;
    this.ListAirlines = config.ListAirlines;
    this.ListRates = config.ListRates;
    this.ListCurrency = config.ListCurrency;
  }

  @Action
  public async saveConfigAirline(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      ApiClient.put('configuration/airline-rate', data).then(
        (response: any) => {
          if (response.success) {
            const result = response.data[0];
            resolve(result);
          }
          resolve({ Error: response.data });
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  @Action({ rawError: true })
  public async updateConfigAirline(data: any): Promise<any> {
    const [debtorId, RateLoca] = data.AirlineSk.split('#Rate#');
    return new Promise((resolve, reject) => {
      ApiClient.patch(
        `configuration/airline-rate/${data.AirlinePk}/${debtorId}/${RateLoca}`,
        data
      ).then(
        (response: any) => {
          if (response.success) {
            const result = response.data[0];
            resolve(result);
          }
          resolve({ Error: response.data });
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  @Action
  public async getConfigAirline(): Promise<any> {
    return new Promise((resolve, reject) => {
      ApiClient.get('configuration/airlines').then(
        (response: any) => {
          if (response.success) {
            const result = response.data[0];
            this.context.commit('setConfig', result);
            resolve(response);
          }
          resolve({ Error: response.data });
        },
        (error) => {
          reject(error);
        }
      );
    });
  }

  @Action
  public async uploadAttachment(file: File): Promise<any> {
    const formData = new FormData();
    formData.append('file', file);
    return new Promise((resolve) => {
      ApiClient.post('file/upload', formData, {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }).then((response: any) => {
        resolve(response);
      });
    });
  }

  @Action
  public async deleteDraft(data: any): Promise<any> {
    return new Promise((resolve, reject) => {
      ApiClient.post('configuration/airline-delete-rate', data).then(
        (response: any) => {
          if (response.success) {
            resolve(response);
          }
          resolve({ Error: response.data });
        },
        (error) => {
          reject(error);
        }
      );
    });
  }
}

export default AirlineModule;
